import { Zap, Search, DollarSign, Truck } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import type { TKey } from "@/i18n/translations";

const values: { icon: typeof Zap; titleKey: TKey; textKey: TKey }[] = [
  { icon: Zap, titleKey: "values.1.title", textKey: "values.1.text" },
  { icon: Search, titleKey: "values.2.title", textKey: "values.2.text" },
  { icon: DollarSign, titleKey: "values.3.title", textKey: "values.3.text" },
  { icon: Truck, titleKey: "values.4.title", textKey: "values.4.text" },
];

const ValueProps = () => {
  const { t } = useLang();
  return (
    <section className="border-b border-border bg-secondary/40 py-10 md:py-24">
      <div className="container">
        <div className="mx-auto max-w-3xl text-center">
          <h2 className="text-[28px] font-bold leading-tight tracking-tight text-foreground sm:text-4xl lg:text-5xl">
            {t("values.h2")}
          </h2>
          <p className="mt-4 text-base leading-relaxed text-muted-foreground sm:text-lg">
            {t("values.subtitle")}
          </p>
        </div>

        <div className="mt-10 grid gap-4 sm:mt-14 sm:grid-cols-2 sm:gap-6 lg:grid-cols-4 lg:gap-7">
          {values.map(({ icon: Icon, titleKey, textKey }) => (
            <div
              key={titleKey}
              className="group relative flex flex-col rounded-2xl border border-border bg-background p-5 transition-all duration-300 hover:-translate-y-1 hover:border-foreground/20 hover:shadow-xl sm:p-7"
            >
              <div className="mb-4 flex h-11 w-11 items-center justify-center rounded-xl bg-primary text-primary-foreground transition-transform duration-300 group-hover:scale-110 sm:mb-5 sm:h-12 sm:w-12">
                <Icon className="h-5 w-5 sm:h-6 sm:w-6" strokeWidth={2} />
              </div>
              <h3 className="text-base font-bold leading-snug text-foreground sm:text-lg">
                {t(titleKey)}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-muted-foreground sm:mt-3">
                {t(textKey)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValueProps;
